var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C9.63334 22 7.54584 21.275 5.73751 19.825C3.92917 18.375 2.76667 16.525 2.25001 14.275C2.18334 13.9917 2.23334 13.7375 2.40001 13.5125C2.56667 13.2875 2.79167 13.1583 3.07501 13.125C3.35834 13.0917 3.60834 13.1583 3.82501 13.325C4.04167 13.4917 4.19167 13.7167 4.27501 14C4.72501 15.75 5.66251 17.1875 7.08751 18.3125C8.51251 19.4375 10.15 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C10.5667 4 9.23751 4.35417 8.01251 5.0625C6.78751 5.77083 5.81667 6.75 5.10001 8H7.00001C7.28334 8 7.52084 8.09583 7.71251 8.2875C7.90417 8.47917 8.00001 8.71667 8.00001 9C8.00001 9.28333 7.90417 9.52083 7.71251 9.7125C7.52084 9.90417 7.28334 10 7.00001 10H3.60001C3.23334 10 2.94167 9.85417 2.72501 9.5625C2.50834 9.27083 2.45834 8.95833 2.57501 8.625C3.27501 6.65833 4.48334 5.0625 6.20001 3.8375C7.91667 2.6125 9.85001 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM13 11.6L15.5 14.1C15.6833 14.2833 15.775 14.5167 15.775 14.8C15.775 15.0833 15.6833 15.3167 15.5 15.5C15.3167 15.6833 15.0833 15.775 14.8 15.775C14.5167 15.775 14.2833 15.6833 14.1 15.5L11.3 12.7C11.2 12.6 11.125 12.4875 11.075 12.3625C11.025 12.2375 11 12.1083 11 11.975V8C11 7.71667 11.0958 7.47917 11.2875 7.2875C11.4792 7.09583 11.7167 7 12 7C12.2833 7 12.5208 7.09583 12.7125 7.2875C12.9042 7.47917 13 7.71667 13 8V11.6Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.19b01d76b19bd5221f696830ed8f24b0.svg";
export { ForwardRef as ReactComponent };